module.exports = __webpack_public_path__ + "img/correct.99e3618c.svg";